import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/stocksWarehouses',
  component: Layout,
  name: 'stocksWarehouses',
  redirect: '/stocksWarehouses/index',
  children: [{
    path: '/stocksWarehouses/index',
    component: () => import('@/views/stocksWarehouses/index'),
    name: 'stocksWarehouses.index',
    meta: {
      title: i18n.t(`message.remainders`)
    }
  },
  {
    path: '/stocksWarehouses/consuption',
    component: () => import('@/views/stocksWarehouses/consuption'),
    name: 'stocksWarehouses.consuption',
    meta: {
      title: i18n.t(`message.materials_consuption`)
    }
  },
 ]
}

export default paymentType